module.exports = __webpack_public_path__ + "resources/img/img_nginx_m.9a52cbb396d1adb62a04b4f7509b5b4a.png";